import {
  UPDATE_EMAIL_CONFIRM_MODAL,
  UPDATE_PREVURL,
} from "@/actions";

export function app(state = {
  prevUrl: null,
  emailConfirmModal: false,
}, action) {
  switch (action.type) {
    case UPDATE_PREVURL:
      return {
        ...state,
        prevUrl: action.payload.prevUrl
      };
    case UPDATE_EMAIL_CONFIRM_MODAL:
      return {
        ...state,
        emailConfirmModal: action.payload.emailConfirmModal,
      };
    default:
      return state
  }
}
